import { Box } from '@chakra-ui/react';
import microsoftLogo from 'assets/images/microsoft.png';

export default function MicrosoftProviderPreview({
    borderStyle = 'solid',
    borderWidth = '1px',
    borderColor = 'gray.400',
    borderRadius = 'md',
    ...rest
}) {
    return (
        <Box
            display="inline-flex"
            alignItems="center"
            border={`${borderWidth} ${borderStyle}`}
            borderColor={borderColor}
            borderRadius={borderRadius}
            h="36px"
            px={2}
            fontSize="sm"
            fontWeight="semibold"
            fontFamily="Segoe UI"
            color="gray.600"
            bg="white"
            w="fit-content"
            minW="200px"
            userSelect="none"
            {...rest}>
            <img
                src={microsoftLogo}
                alt="Microsoft"
                style={{
                    width: 18,
                    height: 18,
                    marginRight: 10,
                    objectFit: 'contain',
                }}
            />
            Sign in with Microsoft
        </Box>
    );
}
